import { Row, Text } from 'components';

const Score = ({ score, sport }) => (
  <Row marg="0 0 13px" ht="55px" centerAll noFlex>
    <Text col="#fff" h1={sport === 'soccer'} size={sport === 'basketball' && '22px'} bold>
      {score?.home || 0} : {score?.away || 0}
    </Text>
  </Row>
);

export default Score;
